import React from 'react';
import isInteger from 'lodash/isInteger';
import range from 'lodash/range';
import styled from 'styled-components';
import { breakpoints } from '@com/core/common/styles/baseStyles';
import { TBannerModule } from '@com/core/common/types/catalog';
import ModuleHeader from '../moduleHeader/moduleHeader';
import BannerContent from './bannerContent/bannerContent';

const commonSpace = 12;

const BannerWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 0 ${commonSpace}px;
    margin: 0;
    justify-content: center;
    align-items: center;
`;

const BannerContainer = styled.div`
    padding: ${commonSpace / 2}px;
    flex: 1;
    box-sizing: border-box;

    @media ${breakpoints.maxDesktopLG} {
        .splitBannerRow {
            flex: 0 0 20% !important; /* TO OVERRIDE INLINE CSS */
        }
    }

    img {
        width: 100%;
        height: auto;
    }
`;

type TProps = {
    moduleData: TBannerModule;
};

const BannerModule = ({ moduleData }: TProps): JSX.Element => {
    const { banners, moduleHeader, numPerRow, textColor, type } = moduleData;
    const innerSpacingValues = range(0, 20, 5);

    // SET CUSTOM PADDING FOR STANDARD GRID BANNERS
    const paddingForStandardBanners = (): any => {
        // DEFAULT 15px. ie: 3rd in innerSpacingValues
        const innerSpacing =
            moduleData && {}.hasOwnProperty.call(moduleData, 'innerSpacing') ? moduleData.innerSpacing : null;

        if (isInteger(innerSpacing)) {
            const paddingPx =
                innerSpacing && innerSpacingValues[innerSpacing] ? innerSpacingValues[innerSpacing] : commonSpace;

            return {
                bannerContainer: {
                    padding: `${paddingPx}px`,
                },
            };
        }
        return {};
    };

    const { bannerContainer, bannerWrapper } = paddingForStandardBanners();

    return (
        <div>
            {moduleHeader && <ModuleHeader className="siteWidthContainer" data={moduleHeader} textColor={textColor} />}
            <BannerWrapper className="siteWidthContainer" style={bannerWrapper}>
                {banners.map(banner => {
                    const bannerClassList =
                        typeof numPerRow === 'number' && numPerRow > 1 ? 'standardBanner' : 'featureBanner';
                    const splitRow = numPerRow === 10 && banner.titleText;

                    return (
                        <BannerContainer
                            key={banner.imageUrl}
                            className={`bannerContainer ${type} ${splitRow ? 'splitBannerRow' : ''}`}
                            style={
                                numPerRow
                                    ? {
                                          ...bannerContainer,
                                          flex: `0 0 ${(1 / numPerRow) * 100}%`,
                                      }
                                    : {}
                            }>
                            <BannerContent bannerStyle={`${type} ${bannerClassList}`} bannerData={banner} />
                        </BannerContainer>
                    );
                })}
            </BannerWrapper>
        </div>
    );
};

export default BannerModule;
